import Captcha from './captcha.js'; //Детектор медиа
import Lang from './lang-message.js';

let AskQuestion = {
  initValidateForm: function(form) {

    $.validator.setDefaults({
      debug: true,
      success: 'valid',
      ignore: '.ignore, *:not([name]), :hidden:not(input[type="file"])'
    });

    form.validate({
      rules: {
        QUESTION_AGREEMENT: {
          required: true
        }        
      },
      messages: {
        QUESTION_AGREEMENT: {
          required: Lang.message.agree_agreement_field
        }
      },
      errorPlacement: function(error,element) {
          return true;
      }
    });
  },
  submitForm: function(form) {
    form.on('submit', function(e){
        e.preventDefault();

        if($(this).valid()){
          var formData = new FormData(this);

          $.ajax({
              url: $(this).attr('action'),
              method: $(this).attr('method'),
              data: formData,
              dataType: 'json',
              processData: false,
              contentType: false,
              success: function(response){
                let popupForm = $('[data-form-question-wrap]').find('[data-form-popup]');
                
                $('[data-img-captcha]').empty().append('<img src="' + response.captcha_img + '" alt="" />');
                $('[data-hidden-input-captcha]').val(response.captcha_code);

                if (response.success) {
                    popupForm.find('[data-content-form-popup]').html('<div class="item item_big">Спасибо!</div><div class="item">Ваше вопрос отправлен</div>');
                    popupForm.addClass('open');

                    $('body').addClass('open-form-popup');

                    AskQuestion.clearForm(form);
                } else {
                    popupForm.find('[data-content-form-popup]').html('<div class="item item_big">Ошибка!</div><div class="item">' + response.description.message + '</div>');

                    popupForm.addClass('open');
                }
              }
          });
        }
    });
  },
  clearForm: function(form){
    form[0].reset();
    form.find('[data-submit-question]').addClass('btn_disabled').attr('disabled');
    form.find('[data-stylized-placeholder]').show();
  },
  setActiveBtnSubmit: function() {
    var _valid = true;

    $('[data-valid-input]').each(function(index) {
      if(!$(this).valid()) {
        _valid = false;
      }
    });

    if(_valid){
      $('[data-submit-question]')
        .removeClass('btn_disabled')
        .removeAttr('disabled');
    }else{
      $('[data-submit-question]')
        .addClass('btn_disabled')
        .attr('disabled');
    }
  }
}

$(document).ready(function ($) {

  let formAskQuestion = $('[data-form-question]');
  if(formAskQuestion.length) {

    /*if (typeof RESUME_VACANCY != 'undefined' && RESUME_VACANCY.length) {
        $('form.question-form input[name=RESUME_VACANCY]').val(RESUME_VACANCY);
    }*/

    Captcha.initCaptcha();

    formAskQuestion.find('[data-mask-phone]').mask('+7 (000) 000-00-00');
  
    AskQuestion.initValidateForm(formAskQuestion);
    AskQuestion.submitForm(formAskQuestion);

    $('[data-valid-input]').on('input', function(){
      AskQuestion.setActiveBtnSubmit();
    });

    $('[data-agreement-input]').on('change', function(){
      AskQuestion.setActiveBtnSubmit();
    });
  }
});



// WEBPACK FOOTER //
// ./components/ask-question.js